/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import { Autocomplete, Box, Divider, TextField } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { useSelector } from 'react-redux';
import type { appConfigs, RootState } from '../types/types';
import { addtemplate } from 'src/services/templateService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { AddCircleStrokeRounded, HelpCircleIcon, Delete03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import { Button, Typography, IconButton } from '@mui/material';
// @ts-ignore
import { html as beautifyHtml } from 'js-beautify';
import {
  ERR_EMAIL,
  ERR_EMAIL_INVALID,
  TEMPLATE_NAME_ERROR,
  TEMPLATE_FROM_NAME_ERROR,
  TEMPLATE_SUBJECT_LINE_ERROR,
  TEMPLATE_PREHEADER_ERROR,
  ADD_TEMPLATE_SUCCESS_MESSAGE,
  TEMPLATE_NAME,
  TEMPLATE_FROM_NAME,
  TEMPLATE_FROM_EMAIL,
  TEMPLATE_PREHEADER,
  TEMPLATE__SUBJECT_LINE,
  UNKNOWN_ERR,
  TEMPLATE_NAME_INVALID,
  TEMPLATE_FROM_NAME_INVALID,
  TEMPLATE_PREHEADER_RESEND_MESSAGE,
  TEMPLATE_RESEND_SUBJECT_LINE_MESSAGE,
  TEMPLATE_REPLY_TO_EMAIL,
  TEMPLATE_FROM_EMAIL_NAME,
} from 'src/constants/constant';
import * as EmailValidator from 'email-validator';
import TemplateSummary from './TemplateSummary';
import type { TemplateSummaryProps } from '../types/types';
import CustomEditor from './CustomEditor';
import MUIModal from '../MUIModal/MUIModal';
import TemplateImageUpload from './TemplateImageUpload';
import he from 'he';
import { v4 as uuidv4 } from 'uuid';
import { styled } from "@mui/material/styles";
import type { TooltipProps } from "@mui/material/Tooltip";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import SendTestEmail from '../SendTestEmail/SendTestEmailTemplate';
import { checkEventPermission, checkSpelling } from "../../common/utility/utility";

export interface NewTemplateInputs {
  clientId?: number;
  templateName: string;
  templateContent?: string | null;
  subjectLine: string;
  fromName: string;
  fromEmail: string;
  replyToEmail?: string | null;
  preheader: string;
  resendSubjectLine?: string | null;
  resendPreheader?: string | null;
  createdBy?: number;
  unsubscribeLink?: string;
  templateIdentifier?: string;
}
interface UploadedFile {
  id: string;
  file?: File;
  preview: string;
  url: string;
  size: string;
}

const validationSchema = Yup.object().shape({
  templateName: Yup.string()
    .required(TEMPLATE_NAME_ERROR)
    .matches(/^\S.*\S$|^\S$/, TEMPLATE_NAME_INVALID),
  fromName: Yup.string()
    .required(TEMPLATE_FROM_NAME_ERROR)
    .matches(/^\S.*\S$|^\S$/, TEMPLATE_FROM_NAME_INVALID),
  fromEmail: Yup.string()
    .required(TEMPLATE_FROM_EMAIL_NAME)
    .matches(/^\S.*\S$|^\S$/, 'Please enter a valid from email name'),
  subjectLine: Yup.string()
    .required(TEMPLATE_SUBJECT_LINE_ERROR)
    .matches(/^\S.*\S$|^\S$/, 'Please enter a valid subject line'),
  preheader: Yup.string()
    .required(TEMPLATE_PREHEADER_ERROR)
    .matches(/^\S.*\S$|^\S$/, 'Please enter a valid preheader'),
  replyToEmail: Yup.string()
    .nullable()
    .notRequired()
    .email(ERR_EMAIL_INVALID)
    .test(
      'is-valid-email',
      ERR_EMAIL_INVALID,
      (value) => (value === '' || EmailValidator.validate(value ?? '')),
    ),
});
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: { backgroundColor: theme.palette.common.black }
}));

const AddTemplateForm: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showFields, setShowFields] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [templateData, setTemplateData] = useState<TemplateSummaryProps>();
  const [fieldCharCount, setFieldCharCount] = useState({
    fromName: 0,
    subjectLine: 0,
    preheader: 0,
    resendSubjectLine: 0,
    resendPreheader: 0,
  });

  const navigate = useNavigate();

  const { user } = useSelector((state: RootState) => state.auth);
  const [editorContent, setEditorContent] = useState<string>('');
  const [links, setLinks] = useState<string[]>([]);
  const [images, setImages] = useState<{ src: string; alt: string }[]>([]);
  const [showImageModal, setShowImageModal] = useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [editorDecodedContent, setEditorDecodedContent] = useState<string>('');
  const [templateName, setTemplateName] = useState<string>('');
  const editorRef = useRef(null);
  const [guid, setGuid] = useState<string>('');
  const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
  const [resendFields, setResendFields] = useState([{ subjectLine: '', preheader: '' }]);
  const [subjectLineSpellingError, setSubjectLineSpellingError] = useState<string>('');
  const [preheaderSpellingError, setPreheaderSpellingError] = useState<string>('');

  const storedAppConfig = localStorage.getItem("appConfigs");
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const parsedAppConfig = storedAppConfig
    ? (JSON.parse(storedAppConfig) as appConfigs[])
    : [];

  const ResendMaxValue: any = parsedAppConfig.find(
    (item) => item.configType === "CampaignSettings" && item.configName === "ResendMaxValue"
  )?.configValue;

  const {
    control,
    setValue,
    handleSubmit,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm<NewTemplateInputs>({
    resolver: yupResolver(validationSchema)
  });
  console.log(editorContent);
  useEffect(() => {
    let storedGuid = localStorage.getItem('templateGuid');
    storedGuid = uuidv4();
    localStorage.setItem('templateGuid', storedGuid);
    setGuid(storedGuid);
  }, []);

  // Handler to add a new resend field set
  const handleAddResendField = (): void => {
    if (resendFields.length < ResendMaxValue) {
      setResendFields([...resendFields, { subjectLine: '', preheader: '' }]);
    }
  };

  // Handler to remove a resend field set
  const handleRemoveResendField = (index: number): void => {
    setResendFields(resendFields.filter((_, i) => i !== index));
  };

  // Handler to update a resend field value
  const handleResendFieldChange = (index: number, field: 'subjectLine' | 'preheader', value: string): void => {
    const updated = [...resendFields];
    updated[index][field] = value;
    setResendFields(updated);
  };

  const updateEditorContent = (newHtml: string): void => {
    if (!newHtml) return;

    // Update the content state
    setEditorContent(newHtml);

    // Update TinyMCE or your CustomEditor via ref
    // @ts-ignore
    if (editorRef.current?.updateContent) {
      // @ts-ignore
      editorRef.current.updateContent(newHtml);
    }
  };

  const onInvalid = (errors: any): void => {
    console.log("Form has errors:", errors);
  };
  const onValid = (data: any): void => {
    setTestEmailModalOpen(true);
  };

  const handleSendTestEmail = (): void => {
    void handleSubmit(onValid, onInvalid)();
  };
  const onSubmit = async (data: NewTemplateInputs): Promise<void> => {
    if (!editorContent || editorContent.trim() === '') {
      NotificationManager.error('Template content cannot be empty.', '', 5000);
      return; // Stop submission
    }
    const hasUnsubscribePlaceholder = editorContent.includes('{{unsubscribelink}}');

    if (!hasUnsubscribePlaceholder && !data.unsubscribeLink) {
      setError('unsubscribeLink', {
        type: 'manual',
        message: 'Please select the Unsubscribe link.',
      });
      return; // Stop submission
    } else {
      clearErrors('unsubscribeLink');
    }
    setIsLoading(true);
    // Define the preheader div content
    const preheaderDiv = `<div id="preheader" style="display: none; max-height: 0px; overflow: hidden; font-size: 0px; color: #ffffff; line-height: 0;">{{preheader}} </div>`;

    // Parse editorContent into a DOM document
    const parser = new DOMParser();
    const doc = parser.parseFromString(editorContent, 'text/html');


    // Check if preheader div already exists
    const existingPreheader = doc.querySelector('#preheader');

    if (!existingPreheader) {
      console.log("🆕 Adding preheader div...");

      // Convert JSX to an actual DOM element
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = preheaderDiv;
      const preheaderElement = tempContainer.firstElementChild as HTMLElement;
      if (preheaderElement) {
        // Find the first <div> in the document
        const firstDiv = doc.querySelector('div');

        if (firstDiv) {
          // ✅ Insert preheader before the first existing div
          firstDiv.insertAdjacentElement('beforebegin', preheaderElement);
        } else {
          // ✅ Find the first valid element
          const validElements = Array.from(doc.body?.children || doc.children).filter(
            (el) => !['HTML', 'HEAD', 'TITLE', 'STYLE'].includes(el.tagName)
          );

          if (validElements.length > 0) {
            // ✅ Insert before the first valid element
            validElements[0].insertAdjacentElement('beforebegin', preheaderElement);
          } else {
            // ✅ Insert at the beginning of the body if no valid element is found
            doc.body.insertAdjacentElement('afterbegin', preheaderElement);
          }
        }
      }
    } else {
      console.log("✅ Preheader div already exists. Skipping insertion.");
    }

    // Convert the modified document back into an HTML string
    const updatedEditorContent = new XMLSerializer().serializeToString(doc);

    // Update editorContent
    setEditorContent(updatedEditorContent);

    // Update the TinyMCE editor content if available
    //@ts-ignore
    if (editorRef.current?.updateContent) {
      //@ts-ignore
      editorRef.current.updateContent(updatedEditorContent);
    }

    console.log(updatedEditorContent);
    // Ensure required fields are handled properly
    data.resendPreheader = data.resendPreheader;
    data.resendSubjectLine = data.resendSubjectLine;
    data.createdBy = user?.id ?? 0;
    data.clientId = user?.clientId ?? 0;
    data.fromEmail = data.fromEmail;
   

    const beautifiedHtml = beautifyHtml(updatedEditorContent, {
      indent_size: 2,
      wrap_line_length: 120,
    });

    // Update editorContent with beautified version
    setEditorContent(beautifiedHtml);

    // Update the TinyMCE editor content if available
    //@ts-ignore
    if (editorRef.current?.updateContent) {
      //@ts-ignore
      editorRef.current.updateContent(beautifiedHtml);
    }

    data.templateContent = beautifiedHtml;
    data.templateIdentifier = guid;

    try {
      const formData = new FormData();

      uploadedFiles.forEach((file) => {
        if (file.file) {
          // ✅ Ensure `file.file` is not undefined before appending
          formData.append('templateImages', file.file, file.file.name);
        }
      });
      console.log(data.templateContent);
      // Prepare `requestData` (JSON data) as a string
      console.log("resendFields", resendFields);

      const ResendPreheaders: any = [];
      resendFields.forEach((resend, index) => {
        if(resend.subjectLine !== '' && resend.preheader !== '') {
          ResendPreheaders.push({
            EmailSendOrder: index + 1,
            Subject: resend.subjectLine,
            Preheader: resend.preheader,
          });
        }
      });
      // return
      const requestData = {
        ClientId: data.clientId,
        TemplateName: data.templateName,
        TemplateContent: data.templateContent,
        SubjectLine: data.subjectLine,
        FromName: data.fromName,
        FromEmail: data.fromEmail,
        ReplyToEmail: data.replyToEmail,
        Preheader: data.preheader,
        // ResendSubjectLine: data.resendSubjectLine,
        // ResendPreheader: data.resendPreheader,
        ResendPreheaders: ResendPreheaders,
        CreatedBy: data.createdBy,
        UnsubscribeUrl: data.unsubscribeLink,
        TemplateIdentifier: data.templateIdentifier,
      };
      console.log(requestData);
      formData.append('requestData', JSON.stringify(requestData));

      // Send FormData to API
      const res = await addtemplate(formData);

      if (res.status === 200) {
        if (res.data.result === 1) {
          setTemplateData(res.data.data);
          // setTimeout(() => {
          //     navigate('/template')
          // }, 1000)
        } else if (res.data.messages === 'Template was not added.') {
          NotificationManager.error('Template name already exists');
        } else if (res.data.messages?.toLowerCase().includes('template with the same name already exists')) {
          NotificationManager.error('Template name already exists');
        }  else {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          NotificationManager.error(UNKNOWN_ERR, '', 5000);
        }
      }
    } catch (error) {
      console.error('Error occurred:', error);
      NotificationManager.error(UNKNOWN_ERR, '', 5000);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = (): void => {
    navigate('/template');
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFieldCharCount((prev) => ({
      ...prev,
      [name]: value.length, // Update the specific field based on the input's name
    }));
  };

  const handleDeleteResendFields = (): void => {
    // Clear only the resend fields
    setValue('resendSubjectLine', '');
    setValue('resendPreheader', '');

    // Reset character counts for these fields
    setFieldCharCount((prev) => ({
      ...prev,
      resendSubjectLine: 0,
      resendPreheader: 0,
    }));

    // Hide the resend fields section
    setShowFields(false);
  };

  useEffect(() => {
    if (!editorContent) {
      setLinks([]);
      setImages([]);
      setEditorDecodedContent('');
      return;
    }

    // Decode HTML entities before parsing
    const decodedContent = he.decode(editorContent);
    const extractLinksAndImages = (
      htmlContent: string,
    ): { links: string[]; images: { src: string; alt: string }[] } => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');
      // Extract links
      const links = Array.from(doc.querySelectorAll('a'))
        .map((a) => a.getAttribute('href') ?? '')
        .filter((href) => href.startsWith('http'));
      const uniqueLinks = Array.from(new Set(links));

      // Extract images with alt text
      const images = Array.from(doc.querySelectorAll('img'))
        .map((img) => ({
          src: img.getAttribute('src') ?? '',
          alt: img.getAttribute('alt') ?? '',
        }))
        .filter((img) => img.src);
      return { links: uniqueLinks, images };
    };

    // Extract links and images after decoding
    const { links, images } = extractLinksAndImages(decodedContent);
    setLinks(links);
    setImages(images);
    setEditorDecodedContent(decodedContent);
  }, [editorContent]);

  const handleImageUpload = (): void => {
    setShowImageModal(true);
  };

  const handleCloseImageModal = (): void => {
    setShowImageModal(false);
  };
  const formData = {
    clientId: user?.clientId ?? 0,
    templateName: watch("templateName"),
    templateContent: editorContent,
    subjectLine: watch("subjectLine"),
    fromName: watch("fromName"),
    fromEmail: watch("fromEmail"),
    preheader: watch("preheader"),
    replyToEmail: watch("replyToEmail"),
  };
  console.log(editorContent);
  return (
    <>      
        <div className="flex justify-between items-center">
          <div className="w-full">
            <div>
              <h1 className="text-2xl text-title font-semibold">
                New Template
              </h1>
              <Box sx={{ flexGrow: 1 }}>
                {templateData ? (
                  <div className='campaign-form-container' style={{ width: '75%' }}>
                    <TemplateSummary template={templateData} label={"Template created successfully"} />
                  </div>
                ) : (
                  <div
                    className="campaign-form-container"
                    style={{ width: '100%' }}
                  >
                    <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              void handleSubmit(onSubmit)(e);
                            }}
                          >
                    <Grid container spacing={0}>

                      <>
                        <Grid item xs={4.8} sx={{ paddingRight: '20px' }}>
                          
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <div className="mb-[30px]">
                                  <Controller
                                    name="templateName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                      <TextField
                                        {...field}
                                        fullWidth
                                        autoComplete="off"
                                        label="Template Name*"
                                        placeholder={TEMPLATE_NAME}
                                        onChange={(event) => {
                                          field.onChange(event);
                                          setTemplateName(event.target.value); // Update the character count
                                        }}
                                        error={Boolean(errors.templateName)}

                                      />
                                    )}
                                  />
                                  {errors.templateName && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                      <img
                                        src="/assets/images/attention.svg"
                                        alt="name"
                                        width={12}
                                        height={12}
                                        className="mr-1"
                                      />
                                      {errors.templateName?.message}{' '}
                                      {/* Show the error message */}
                                    </div>
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <div className="mb-[10px]">
                                <Controller
                                  name="fromName"
                                  control={control}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <>
                                      <TextField
                                        {...field}
                                        fullWidth
                                        autoComplete="off"
                                        label="From Name*"
                                        placeholder={TEMPLATE_FROM_NAME}
                                        error={Boolean(errors.fromName)}
                                        inputProps={{
                                          maxLength: 100,
                                        }}
                                        onChange={(event) => {
                                          field.onChange(event); // Pass the change to react-hook-form
                                          handleInputChange(event); // Update the character count
                                        }}

                                      />
                                      {errors.fromName && (
                                        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                          <img
                                            src="/assets/images/attention.svg"
                                            alt="name"
                                            width={12}
                                            height={12}
                                            className="mr-1"
                                          />
                                          {errors.fromName?.message}{' '}
                                          {/* Show the error message */}
                                        </div>
                                      )}
                                      <Typography
                                        variant="caption"
                                        style={{
                                          display: 'block',
                                          textAlign: 'right',
                                          color:
                                            fieldCharCount.fromName === 100
                                              ? 'red'
                                              : '#77869e',
                                        }}
                                      >
                                        {`${100 - fieldCharCount.fromName
                                          } characters left`}
                                      </Typography>
                                    </>
                                  )}
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12}>
                              <div className="mb-[30px]">
                                <Controller
                                  name="fromEmail"
                                  control={control}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <div className="flex items-center">
                                      {/* Input Field (No Border) */}
                                      <TextField
                                        {...field}
                                        fullWidth
                                        autoComplete="off"
                                        label="From Email Name*"
                                        placeholder="Enter your from email name"
                                        onChange={(e) => {
                                          const prefix =
                                            e.target.value.split('@')[0]; // Keep only text before "@"
                                          field.onChange(prefix); // Update field value
                                        }}

                                        error={Boolean(errors.fromEmail)}
                                      />
                                      
                                      </div>
                                  )}
                                />
                                {/* Validation Error Message */}
                                {errors.fromEmail && (
                                  <div className="flex items-center text-primary mt-1 text-md font-normal">
                                    <img
                                      src="/assets/images/attention.svg"
                                      alt="error"
                                      width={12}
                                      height={12}
                                      className="mr-1"
                                    />
                                    <span>{errors.fromEmail?.message}</span>
                                  </div>
                                )}
                              </div>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <div className="mb-[30px]">
                                  <Controller
                                    name="replyToEmail"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                      <TextField
                                        {...field}
                                        fullWidth
                                        autoComplete="off"
                                        label="Reply-To Email"
                                        placeholder={TEMPLATE_REPLY_TO_EMAIL}
                                        error={Boolean(errors.replyToEmail)}
                                        
                                      />
                                    )}
                                  />
                                  {errors.replyToEmail && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                      <img
                                        src="/assets/images/attention.svg"
                                        alt="name"
                                        width={12}
                                        height={12}
                                        className="mr-1"
                                      />
                                      {errors.replyToEmail?.message}{' '}
                                      {/* Show the error message */}
                                    </div>
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <div className="mb-[30px]">
                                <Controller
                                  name="unsubscribeLink"
                                  control={control}
                                  render={({ field }) => (
                                    <Autocomplete
                                      options={links}
                                      getOptionLabel={(option) => option}
                                      popupIcon={
                                        <HugeiconsIcon
                                          icon={ArrowDown01Icon}
                                          size={18}
                                          color="#3A3A3A"
                                          strokeWidth={0.2}

                                        />
                                      }
                                      value={field.value}
                                      onChange={(_, selectedLink) =>
                                        field.onChange(selectedLink)
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Unsubscribe Link"
                                          placeholder="Select a link"
                                          error={Boolean(errors.unsubscribeLink)}
                                          helperText={errors.unsubscribeLink?.message}

                                        />
                                      )}
                                    />
                                  )}
                                />
                              </div>
                            </Grid>

                            <Grid item xs={12}>
                              <div className="mb-[10px]">
                                <Controller
                                  name="subjectLine"
                                  control={control}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <>
                                      <TextField
                                        {...field}
                                        fullWidth
                                        autoComplete="off"
                                        label="Subject Line*"
                                        placeholder={TEMPLATE__SUBJECT_LINE}
                                        error={Boolean(errors.subjectLine)}
                                        inputProps={{
                                          maxLength: 200,
                                        }}
                                        onChange={async (event) => {
                                          field.onChange(event); // Pass the change to react-hook-form
                                          handleInputChange(event); // Update the character count
                                          await checkSpelling(event.target.value) ? setSubjectLineSpellingError('') : setSubjectLineSpellingError('There are spelling mistakes');
                                        }}

                                      />
                                      {errors.subjectLine && (
                                        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                          <img
                                            src="/assets/images/attention.svg"
                                            alt="name"
                                            width={12}
                                            height={12}
                                            className="mr-1"
                                          />
                                          {errors.subjectLine?.message}{' '}
                                          {/* Show the error message */}
                                        </div>
                                      )}
                                      
                                      <Typography
                                        variant="caption"
                                        style={{
                                          marginTop: '4px',
                                          display: 'block',
                                          textAlign: 'right',
                                          color:
                                            fieldCharCount.subjectLine === 200
                                              ? 'red'
                                              : '#77869e',
                                        }}
                                      >
                                        {`${200 - fieldCharCount.subjectLine
                                          } characters left`}
                                      </Typography>
                                    </>
                                  )}
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12}>
                              <div>
                                <Controller
                                  name="preheader"
                                  control={control}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <>
                                      <TextField
                                        {...field}
                                        fullWidth
                                        autoComplete="off"
                                        label="Preheader*"
                                        placeholder={TEMPLATE_PREHEADER}
                                        error={Boolean(errors.preheader)}
                                        inputProps={{
                                          maxLength: 500,
                                        }}
                                        onChange={async (event) => {
                                          field.onChange(event); // Pass the change to react-hook-form
                                          handleInputChange(event); // Update the character count
                                          await checkSpelling(event.target.value) ? setPreheaderSpellingError('') : setPreheaderSpellingError('There are spelling mistakes');
                                        }}

                                      />
                                      {errors.preheader && (
                                        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                          <img
                                            src="/assets/images/attention.svg"
                                            alt="name"
                                            width={12}
                                            height={12}
                                            className="mr-1"
                                          />
                                          {errors.preheader?.message}{' '}
                                          {/* Show the error message */}
                                        </div>
                                      )}
                                      
                                      <Typography
                                        variant="caption"
                                        style={{
                                          marginTop: '4px',
                                          display: 'block',
                                          textAlign: 'right',
                                          color:
                                            fieldCharCount.preheader === 500
                                              ? 'red'
                                              : '#77869e',
                                        }}
                                      >
                                        {`${500 - fieldCharCount.preheader
                                          } characters left`}
                                      </Typography>
                                    </>
                                  )}
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12}>
                              {!showFields ? (
                                <div
                                  className="flex items-center justify-center mb-[10px] cursor-pointer"
                                  style={{ textAlign: 'center' }}
                                  onClick={() => {
                                    setResendFields([{ subjectLine: '', preheader: '' }]);
                                    setShowFields(true)
                                  }}
                                >
                                  <HugeiconsIcon
                                    icon={AddCircleStrokeRounded}
                                    size={18}
                                    color="#3a3a3a"
                                    strokeWidth={0.2}
                                  />

                                  <Button
                                    disableRipple
                                    sx={{
                                      color: "#3a3a3a",
                                      textTransform: 'none',
                                      fontWeight: 500,
                                      '&:hover': {
                                        backgroundColor: 'transparent',
                                      },
                                    }}
                                  >
                                     <span className="flex items-center font-medium text-[#3a3a3a]">
                                        <span style={{ textDecoration: 'underline' }}>
                                            Add resend subject line & preheader
                                        </span>
                                     </span>
                                    
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontStyle: 'italic',
                                        color: '#3a3a3a'
                                      }}
                                    >
                                      (optional)
                                    </Typography>
                                  </Button>

                                  <BootstrapTooltip title={TEMPLATE_PREHEADER_RESEND_MESSAGE}>
                                    <span>
                                      <HugeiconsIcon
                                        icon={HelpCircleIcon}
                                        size={18}
                                        color="#3a3a3a"
                                        strokeWidth={0.2}
                                      />
                                    </span>
                                  </BootstrapTooltip>
                                </div>
                              ) : (
                                    <>
                                      {
                                        resendFields.length === 1 && (

                                          <div
                                            className="flex items-center justify-center mb-[10px] cursor-pointer"
                                            style={{ textAlign: 'center' }}
                                          >
                                            <HugeiconsIcon
                                              icon={Delete03Icon}
                                              size={18}
                                              color="red"
                                              strokeWidth={.2}
                                            />
                                            <Button
                                              disableRipple
                                              sx={{
                                                color: 'red',
                                                textTransform: 'none',
                                                fontWeight: 400,
                                                '&:hover': {
                                                  backgroundColor: 'transparent',
                                                },
                                              }}
                                              onClick={() => {
                                                setShowFields(false);
                                                // setResendFields([{ subjectLine: '', preheader: '' }]);
                                                handleRemoveResendField(0)
                                              }}
                                            >
                                              Delete resend subject line & preheader
                                            </Button>

                                            <BootstrapTooltip title={TEMPLATE_RESEND_SUBJECT_LINE_MESSAGE}>

                                              <HugeiconsIcon
                                                icon={HelpCircleIcon}
                                                size={18}
                                                color="#3a3a3a"
                                                strokeWidth={0.2}
                                              />
                                            </BootstrapTooltip>
                                          </div>
                                        )
                                      }
                                    </>
                              )}
                            </Grid>

                            {showFields && (
                                <>
                                  {resendFields.map((resend, idx) => (
                                    <React.Fragment key={idx}>
                                      <Grid item xs={12}>
                                        <div className="mb-[10px] mt-[10px] flex items-center">
                                          <div style={{ width: '48%' }}>
                                            <TextField
                                              fullWidth
                                              autoComplete="off"
                                              label={`Resend Subject Line ${idx + 1}`}
                                              placeholder="Resend Subject Line"
                                              value={resend.subjectLine}
                                              inputProps={{ maxLength: 200 }}
                                              onChange={e => handleResendFieldChange(idx, 'subjectLine', e.target.value)}
                                              sx={{ marginRight: 2 }}
                                            />
                                            <Typography
                                              variant="caption"
                                              color={resend.subjectLine.length === 200 ? 'error' : 'textSecondary'}
                                              style={{ marginTop: '4px', display: 'block', textAlign: 'right' }}
                                            >
                                              {`${200 - resend.subjectLine.length} characters left`}
                                            </Typography>
                                          </div>
                                          <div style={{ width: '48%', marginLeft: '2%' }}>
                                            <TextField
                                              fullWidth
                                              autoComplete="off"
                                              label={`Resend Preheader ${idx + 1}`}
                                              placeholder="Resend Preheader"
                                              value={resend.preheader}
                                              inputProps={{ maxLength: 500 }}
                                              onChange={e => handleResendFieldChange(idx, 'preheader', e.target.value)}
                                              sx={{ marginRight: 2 }}
                                            />
                                            <Typography
                                              variant="caption"
                                              color={resend.preheader.length === 500 ? 'error' : 'textSecondary'}
                                              style={{ marginTop: '4px', display: 'block', textAlign: 'right' }}
                                            >
                                              {`${500 - resend.preheader.length} characters left`}
                                            </Typography>
                                          </div>

                                          {resendFields.length > 1 && (
                                            <IconButton onClick={() => handleRemoveResendField(idx)} color="error" sx={{ top: '-12px'}}>
                                              <HugeiconsIcon icon={Delete03Icon} size={18} />
                                            </IconButton>
                                          )}
                                        </div>
                                      </Grid>
                                    </React.Fragment>
                                  ))}
                                  {resendFields.length < ResendMaxValue && (
                                    <div className="flex justify-center">
                                      <Button onClick={handleAddResendField} variant='outlined' sx={{ borderRadius: '50px', padding: '6px 16px', textTransform: 'none', mt: 1, mb: 2 }}>
                                        Add resend subject line & preheader
                                      </Button>
                                    </div>
                                  )}
                                </>
                            )}

                            <Grid container spacing={2}></Grid>

                            
                        </Grid>
                        <Grid item xs={7.2} sx={{ paddingLeft: '20px' }}>
                          <CustomEditor
                            onHtmlChange={setEditorContent}
                            initialHtml={editorContent}
                            onImageUpload={handleImageUpload}
                            editorRef={editorRef}
                            onSendTestEmail={() => void handleSendTestEmail()}
                          />
                          {/* <img src={'/assets/images/TemplatePreview1.png'}  alt=""  className="icon-hover"/> */}
                        </Grid>
                      </>

                    </Grid>
                    <Divider
                              sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '20px' }}
                            />
                            <div className="flex justify-between items-center gap-x-3.5">
                              <OutlineButton
                                color="gray"
                                onClick={handleCancel}
                                disabled={isLoading}
                                type='button'
                              >
                                Cancel
                              </OutlineButton>
                              <GradientButton
                                type="submit"
                                color="red"
                                onClick={handleCancel}
                                disabled={isLoading || !checkEventPermission("TEMPLATE_ADD")}
                              >
                                {!isLoading ? (
                                  'Create Template'
                                ) : (
                                  <span className="loading loading-spinner loading-xs text-white"></span>
                                )}
                              </GradientButton>
                            </div>
                    </form>
                  </div>
                )}

              </Box>
            </div>
            <MUIModal
              openModal={showImageModal}
              closeModal={handleCloseImageModal}
              title="Upload Images"
              width="50%"
            >

              <TemplateImageUpload
                closeModal={handleCloseImageModal}
                imageData={images}
                onFilesUpload={(files) => setUploadedFiles(files)}
                updateEditorContent={updateEditorContent}
                TemplateName={templateName}
                editorContent={editorContent}
              />

            </MUIModal>
          </div>
        </div>      
      <SendTestEmail open={testEmailModalOpen} onClose={() => setTestEmailModalOpen(false)} TemplateData={formData} />
    </>
  );
};

export default AddTemplateForm;
